module.exports = __webpack_public_path__ + "static/media/whiteHelp.eb79560b.svg";